import { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css"; // Import the AOS styles
import { Helmet } from 'react-helmet';

export const Privacy = () => {
  useEffect(() => {
    // Initialize AOS when the component mounts
    AOS.init({
      duration: 1000, // Animation duration
      easing: "ease-out", // Animation easing
      once: false, // Whether animation should happen once or not
    });
  }, []);
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Lone Wolf Writes</title>
        <meta name="description" content="Lone Wolf Writes Privacy Policy" />
        <link rel="canonical" href="https://www.mysite.com/seo/backlink-strategies" />
      </Helmet>
      <main>
        <div className="container mt-4 mb-4"
          data-aos="fade-up" // AOS animation for the image
          data-aos-delay="300" // Delay for animation
        >
          <h1>Privacy Policy</h1>
          <p>At Lone Wolf Writes, your privacy is of utmost importance to us. This Privacy Policy outlines how we collect, use, and protect your information when you interact with our platform. By using Lone Wolf Writes, you agree to the terms described in this policy.</p>
          <h2>Information We Collect</h2>
          <p><strong>We may collect the following types of information:</strong></p>
          <p>Personal Information: When you register, subscribe, or contact us, we may collect your name, email address, or other personal details.</p>
          <p>Non-Personal Information: We collect data such as browser type, IP address, and device information to improve website functionality.</p>
          <p>Content Contributions: Any blogs, poems, comments, or other submissions you make are stored for display on our platform.</p>
          <h2>How We Use Your Information</h2>
          <p>To provide and improve our services and content.</p>
          <p>To personalize your experience and tailor content to your interests.</p>
          <p>To communicate updates, newsletters, or promotional offers (only if consented).</p>
          <p>To maintain security and prevent fraudulent or unauthorized activity.</p>
          <h2>Cookies and Tracking Technologies</h2>
          <p>Lone Wolf Writes may use cookies and similar technologies to enhance your browsing experience. These help us analyze site traffic, remember your preferences, and improve website performance. You can control cookies through your browser settings.</p>
          <h2>Sharing of Information</h2>
          <p><strong>We do not sell, trade, or share your personal information with third parties, except:</strong></p>
          <p>With service providers who assist in website operations (under strict confidentiality agreements).</p>
          <p>When required by law or to protect the rights and safety of Lone Wolf Writes or its users.</p>
          <h2>Security</h2>
          <p>We implement standard security measures to protect your information. However, no online platform can guarantee absolute security. Please ensure your personal credentials are secure.</p>
          <h2>Third-Party Links</h2>
          <p>Lone Wolf Writes may contain links to external websites. We are not responsible for their privacy practices or content. Please review the privacy policies of these third-party sites before engaging with them.</p>
          <h2>Your Rights</h2>
          <p><strong>You have the right to:</strong></p>
          <p>Access, update, or delete your personal information by contacting us.</p>
          <p>Opt out of receiving promotional emails by clicking the unsubscribe link.</p>
          <p>Withdraw consent where applicable under local laws.</p>
          <h2>Children's Privacy</h2>
          <p>Our platform is not intended for individuals under 13 years of age. We do not knowingly collect personal information from children.</p>
          <h2>Changes to the Privacy Policy</h2>
          <p>We may update this Privacy Policy periodically. Any changes will be posted on this page with a revised effective date. Please review it regularly to stay informed.</p>
          <h2>Contact Us</h2>
          <p>If you have any questions or concerns about this Privacy Policy or your personal information, please reach out to us at:</p>
          <p><strong>Email: </strong> <a href="mailto:pranav.gaikwad@lonewolfwrites.com" style={{ textDecoration: "none", color: "red" }}> pranav.gaikwad@lonewolfwrites.com</a></p>
          <p>By using Lone Wolf Writes, you agree to this Privacy Policy and its terms. Thank you for trusting us with your privacy!</p>
        </div>
      </main>
    </>
  )
}
